import { Warning } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import { GenConfirmationDialog } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import { WOErrorTokens } from '../../../../common/enums/enums';

const CONTROLLED_ERRORS = [
  WOErrorTokens.DUPLICATED,
  WOErrorTokens.SERVICE_LIMIT_EXCEEDED,
];

export default function NewOrderErrorCreating({ error, onClose, onConfirm }) {
  const { t } = useTranslation(['orders', 'global']);

  return (
    <GenConfirmationDialog
      open={!!error && !CONTROLLED_ERRORS.includes(error.token)}
      onClose={onClose}
      onRefuse={onClose}
      onConfirm={onConfirm}
      title={t('newOrder.errorCreatingTitle')}
      titleIconColor={'warning'}
      closeText={t('newOrder.cancel')}
      confirmText={t('newOrder.retry')}
      titleIcon={Warning}
      sx={{
        '& .MuiDialog-paper': {
          padding: '24px',
        },
        '& .MuiDialogActions-root': {
          padding: '20px',
        },
      }}
    >
      <Grid
        container
        direction={'row'}
        alignItems="center"
        justifyContent={'center'}
      >
        <Grid item>
          <Typography variant="Body1">{t('newOrder.errorMessage')}</Typography>
        </Grid>
      </Grid>
    </GenConfirmationDialog>
  );
}
